console.log("Analytics Env:", process.env.NODE_ENV);

type Amplitude = {
  init: (apiKey: string, options: { defaultTracking: boolean }) => void;
  setUserId: (userId: string) => void;
  identify: (event: any) => void;
  track: (...args: any[]) => void;
  Identify: typeof Identify;
};

interface MakeAnalyticsDependencies {
  amplitude: Amplitude;
}

export declare class Identify {
  set(property: string, value: any): Identify;
}

export function makeAnalytics(deps: MakeAnalyticsDependencies) {
  const apiKey =
    process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ??
    process.env.EXPO_PUBLIC_AMPLITUDE_API_KEY;
  if (!apiKey) throw new Error("Amplitude API key not found");
  deps.amplitude.init(apiKey, {
    defaultTracking: true,
  });

  const analytics = {
    isTest: false,
    setIsTest: () => (analytics.isTest = true),
    setUser: (userId: string, platform: "web" | "desktop" | "mobile") => {
      if (userId === "MOCK_USER_ID") return; // onboarding
      if (analytics.isTest) return;

      const identifyEvent = new deps.amplitude.Identify();
      identifyEvent.set("app_platform", platform);
      deps.amplitude.identify(identifyEvent);

      return deps.amplitude.setUserId(userId);
    },
    track: (...args: Parameters<typeof deps.amplitude.track>) => {
      if (analytics.isTest) return;
      deps.amplitude.track(...args);
    },
  } as Analytics;

  return analytics;
}

export type Analytics = {
  isTest: boolean;
  setIsTest: () => void;
  setUser: (userId: string, platform: "web" | "desktop" | "mobile") => void;
  track: (eventName: string, eventProperties?: Record<string, any>) => void;
};
